const DEFAULT_PREFIX = "dtc";
const VALUE_UPDATE_EVENT = "update:value";
const MEMBER_UPDATE_EVENT = "update:member";
const OPTIONS_UPDATE_EVENT = "update:options";
const SETTINGS_UPDATE_EVENT = "update:settings";
const SETTINGS_THEME_KEY = "dialtoneCombinatorTheme";
const SETTINGS_SIDEBAR_KEY = "dialtoneCombinatorSidebar";
const SETTINGS_SCHEME_KEY = "dialtoneCombinatorCodeScheme";
const SETTINGS_VERBOSE_KEY = "dialtoneCombinatorCodeVerbose";
const SETTINGS_INDENT_KEY = "dialtoneCombinatorCodeIndent";
const SETTINGS_POSITIONING_KEY = "dialtoneCombinatorRendererPositioning";
const SETTINGS_BACKGROUND_KEY = "dialtoneCombinatorRendererBackground";
export {
  DEFAULT_PREFIX,
  MEMBER_UPDATE_EVENT,
  OPTIONS_UPDATE_EVENT,
  SETTINGS_BACKGROUND_KEY,
  SETTINGS_INDENT_KEY,
  SETTINGS_POSITIONING_KEY,
  SETTINGS_SCHEME_KEY,
  SETTINGS_SIDEBAR_KEY,
  SETTINGS_THEME_KEY,
  SETTINGS_UPDATE_EVENT,
  SETTINGS_VERBOSE_KEY,
  VALUE_UPDATE_EVENT
};
//# sourceMappingURL=constants.js.map
